import { legacyRequest } from './client';

export interface GiveawayEntry {
  /** The caught icon: a `giveaway` row. */
  giveawayId: number;
  /** The stand it was caught on. */
  standId: number;
  email: string;
  phone: string;
  /** Name and city, in the free-text `content` column. */
  nameAndCity: string;
  /** Answer to the fair's question, if it asks one; `giveaway_application.answer`. */
  answer?: string;
}

/**
 * Enters the "Lov na blago" draw, as `PrizeForm` did: a `giveaway_application`
 * row, tied to the signed-in visitor. The endpoint requires `email` and a
 * non-empty `content`.
 *
 * The legacy Serbian fair relabelled the fields through its translations —
 * "Ime i prezime, grad" over `phone`, "Broj telefona" over `content` — so its
 * rows hold them swapped. They go to the matching columns here.
 */
export async function enterGiveaway(token: string, entry: GiveawayEntry): Promise<void> {
  await legacyRequest<unknown>('/giveaway/apply', {
    method: 'POST',
    token,
    form: {
      giveaway: entry.giveawayId,
      stand: entry.standId,
      email: entry.email,
      phone: entry.phone,
      content: entry.nameAndCity,
      ...(entry.answer !== undefined && { answer: entry.answer }),
    },
  });
}
